import { ZmDeclarationEntry } from "../types";

function normalizeDeclaration(entry: ZmDeclarationEntry): ZmDeclarationEntry {
  return {
    ...entry,
    createdAt: entry.createdAt ?? entry.uploadedAt ?? "",
    uploadedAt: entry.uploadedAt ?? null,
    amount: entry.amount ?? null,
  };
}

export function parseZmDeclarationsResponse(
  data: unknown
): ZmDeclarationEntry[] {
  let payload = data;

  if (typeof payload === "string") {
    try {
      payload = JSON.parse(payload) as unknown;
    } catch {
      return [];
    }
  }

  if (payload == null) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload.map((entry) =>
      normalizeDeclaration(entry as ZmDeclarationEntry)
    );
  }

  if (typeof payload === "object") {
    const record = payload as Record<string, unknown>;
    for (const key of ["pastDeclarations", "declarations", "data", "items"]) {
      const value = record[key];
      if (Array.isArray(value)) {
        return value.map((entry) =>
          normalizeDeclaration(entry as ZmDeclarationEntry)
        );
      }
    }
  }

  return [];
}
